import { AxiosInstance, AxiosRequestConfig } from 'axios'

import { UserServiceOfferInHospitalRepository } from './domain/UserServiceOfferInHospitalRepository'

import { UserServiceOfferInHospitalCategories } from '../../contracts/service-offer/UserServiceOfferInHospitalCategory'
import {
  UserServiceOfferInHospitalFilteredListRequestParams,
  UserServiceOfferInHospitalFilteredListView,
} from '../../contracts/service-offer/UserServiceOfferInHospitalFilteredListView'
import {
  UserServiceOfferInHospitalTreatmentRequestParams,
  UserServiceOfferInHospitalTreatmentResponse,
} from '../../contracts/service-offer/UserServiceOfferInHospitalTreatment'
import { AxiosErrorHandler } from '../../foundation'

export class UserApiServiceOfferInHospital implements UserServiceOfferInHospitalRepository {
  private errorHandler: AxiosErrorHandler

  constructor(private axios: AxiosInstance) {
    this.errorHandler = new AxiosErrorHandler()
  }

  getFilteredList = async (params: UserServiceOfferInHospitalFilteredListRequestParams) => {
    const config: AxiosRequestConfig<UserServiceOfferInHospitalFilteredListRequestParams> = {
      url: '/service-offer/query/user/filter-list-views/process',
      method: 'post',
      data: params,
    }

    try {
      const { data } = await this.axios.request<UserServiceOfferInHospitalFilteredListView>(config)
      return data
    } catch (error) {
      return this.errorHandler.handle(error)
    }
  }

  getTreatmentCategory = async (hospitalId: number) => {
    const config: AxiosRequestConfig<{ hospitalId: number }> = {
      url: '/service-offer/query/user/treatment-category-count/process',
      method: 'post',
      data: { hospitalId },
    }

    try {
      const { data } = await this.axios.request<UserServiceOfferInHospitalCategories>(config)
      return data
    } catch (error) {
      return this.errorHandler.handle(error)
    }
  }

  getTreatment = async ({ hospitalId, categoryId }: UserServiceOfferInHospitalTreatmentRequestParams) => {
    const config: AxiosRequestConfig<UserServiceOfferInHospitalTreatmentRequestParams> = {
      url: '/service-offer/query/user/treatment-count/process',
      method: 'post',
      data: { hospitalId, categoryId },
    }

    try {
      const { data } = await this.axios.request<UserServiceOfferInHospitalTreatmentResponse>(config)
      return data
    } catch (error) {
      return this.errorHandler.handle(error)
    }
  }
}
